// extracted by mini-css-extract-plugin
export var wordContainer = "_j1-0";